<h1 mat-dialog-title>{{mesaj}}</h1>
<div mat-dialog-content>
  <!-- <p>What's your favorite animal?</p> -->

</div>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="true" class="edit-button">Aproba</button>
  <button mat-button [mat-dialog-close]="false" color="warn">Renunta</button>
</div>
